// import { useNavigate } from "react-router-dom";

// const EmailVerifiedNotice = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-lime-100 to-lime-300 p-6">
//       <div className="max-w-3xl bg-white rounded-xl shadow-lg p-10 text-center space-y-6">
//         <div className="text-green-500 text-6xl mb-4">✓</div>
//         <h1 className="text-4xl font-extrabold text-black">
//           Registration Submitted Successfully!
//         </h1>
//         <div className="space-y-4 text-left">
//           <p className="text-lg text-black font-bold">
//             ✅ Your email has been verified and your registration has been
//             submitted.
//           </p>
//           <p className="text-lg text-black font-bold">
//             📋 Your application is now pending admin approval.
//           </p>
//           <p className="text-lg text-black font-bold">
//             📧 You will receive your User ID and Password via email once the
//             admin approves your membership.
//           </p>
//           <p className="text-lg text-black font-bold">
//             💳 After receiving your credentials, log in and complete your
//             membership registration fee to unlock your dashboard and become an
//             official member of RGCC.
//           </p>
//         </div>
//         <div className="flex space-x-4 justify-center mt-6">
//           <button
//             onClick={() => navigate("/")}
//             className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-full font-bold transition"
//           >
//             Return Home
//           </button>
//           <button
//             onClick={() => navigate("/login")}
//             className="bg-lime-400 hover:bg-black hover:text-white px-6 py-3 rounded-full font-bold transition"
//           >
//             Go to Login
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmailVerifiedNotice;

import { Link, useNavigate } from "react-router-dom";

const EmailVerifiedNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-lime-50 via-white to-emerald-50 p-4 md:p-6">
      <div className="max-w-4xl bg-white rounded-2xl shadow-2xl p-6 md:p-10 text-center space-y-8">
        {/* Success Icon */}
        <div className="relative">
          <div className="w-32 h-32 bg-gradient-to-br from-lime-400 to-green-500 rounded-full flex items-center justify-center mx-auto shadow-lg mb-6">
            <div className="text-white text-5xl font-bold">✓</div>
          </div>
          <div className="absolute top-0 right-0 md:right-10 w-16 h-16 bg-gradient-to-br from-green-300 to-emerald-400 rounded-full blur-xl opacity-50"></div>
          <div className="absolute bottom-0 left-0 md:left-10 w-20 h-20 bg-gradient-to-br from-lime-300 to-lime-400 rounded-full blur-xl opacity-50"></div>
        </div>

        {/* Main Heading */}
        <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-gray-900 to-lime-700 bg-clip-text text-transparent">
          Registration Successfully Submitted!
        </h1>

        {/* Application Tracking Info */}
        <div className="bg-gradient-to-r from-lime-50 to-emerald-50 border border-lime-200 rounded-xl p-6 mb-6">
          <div className="flex items-center justify-center mb-4">
            <svg
              className="w-6 h-6 text-lime-600 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h2 className="text-xl font-bold text-gray-800">
              Application Tracking Information
            </h2>
          </div>
          <p className="text-gray-700 mb-3">
            📧 You have received an email with your{" "}
            <strong className="text-lime-700">
              Application Tracking Number
            </strong>
            .
          </p>
          <p className="text-gray-700">
            🔍 Use this tracking number to monitor your application's approval
            stages in the{" "}
            <Link to="/membership" className="text-lime-700">
              Membership Page
            </Link>
            .
          </p>
        </div>

        {/* 4-Step Verification Process */}
        <div className="mb-8">
          <div className="flex items-center mb-6">
            <div className="w-2 h-8 bg-gradient-to-b from-lime-500 to-lime-600 rounded-full mr-3"></div>
            <h2 className="text-2xl font-bold text-gray-900">
              Your 4-Step Membership Journey
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Step 1 */}
            <div className="bg-gradient-to-b from-white to-gray-50 border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-lime-500 to-lime-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg">
                1
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                Email Verification
              </h3>
              <p className="text-gray-600 text-sm">
                <span className="text-green-500 font-bold">✓ Completed</span>
                <br />
                Your email has been successfully verified
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-gradient-to-b from-white to-gray-50 border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-gray-400 to-gray-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg">
                2
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Admin Review</h3>
              <p className="text-gray-600 text-sm">
                <span className="text-amber-500 font-bold">● In Progress</span>
                <br />
                Application under administrative review
              </p>
            </div>

            {/* Step 3 */}
            <div className="bg-gradient-to-b from-white to-gray-50 border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-gray-300 to-gray-400 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg">
                3
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                Credentials Issuance
              </h3>
              <p className="text-gray-600 text-sm">
                Upon approval, receive your User ID and Password via email
              </p>
            </div>

            {/* Step 4 */}
            <div className="bg-gradient-to-b from-white to-gray-50 border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-gradient-to-br from-gray-300 to-gray-400 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg">
                4
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                Payment & Activation
              </h3>
              <p className="text-gray-600 text-sm">
                Complete membership fee payment to activate your account
              </p>
            </div>
          </div>
        </div>

        {/* Next Steps */}
        <div className="bg-gradient-to-r from-lime-100 to-transparent p-6 rounded-xl border border-lime-200 mb-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Next Steps:</h3>
          <div className="space-y-3 text-left">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-lime-100 rounded-full flex items-center justify-center mr-3 mt-1">
                <span className="text-lime-600 font-bold">1</span>
              </div>
              <p className="text-gray-700">
                Check your email for the{" "}
                <strong>Application Tracking Number</strong>
              </p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-lime-100 rounded-full flex items-center justify-center mr-3 mt-1">
                <span className="text-lime-600 font-bold">2</span>
              </div>
              <p className="text-gray-700">
                Visit the{" "}
                <Link to="/membership" className="text-lime-700">
                  Membership Page
                </Link>{" "}
                to track your application status
              </p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-lime-100 rounded-full flex items-center justify-center mr-3 mt-1">
                <span className="text-lime-600 font-bold">3</span>
              </div>
              <p className="text-gray-700">
                Await email notification when your application is approved
              </p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-lime-100 rounded-full flex items-center justify-center mr-3 mt-1">
                <span className="text-lime-600 font-bold">4</span>
              </div>
              <p className="text-gray-700">
                Once approved, log in and complete your membership fee payment
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <button
            onClick={() => navigate("/")}
            className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-8 py-3 rounded-xl font-bold transition duration-200 hover:shadow-lg flex items-center justify-center"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Return Home
          </button>

          <button
            onClick={() => navigate("/membership")}
            className="bg-gradient-to-r from-lime-500 to-lime-600 hover:from-lime-600 hover:to-lime-700 text-white px-8 py-3 rounded-xl font-bold transition duration-200 hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Track Application Status
          </button>

          <button
            onClick={() => navigate("/login")}
            className="bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black text-white px-8 py-3 rounded-xl font-bold transition duration-200 hover:shadow-lg flex items-center justify-center"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
              />
            </svg>
            Go to Login
          </button>
        </div>

        {/* Additional Information */}
        <div className="pt-6 mt-6 border-t border-gray-200">
          <p className="text-gray-600 text-sm">
            Need assistance? Contact our membership team at{" "}
            <span
              // href="mailto:membership@rgcc.com"
              className="text-lime-600 font-semibold hover:underline"
            >
              +88 01766693142
            </span>
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Typical processing time: 3-5 business days
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerifiedNotice;
